import Splide from '@splidejs/splide';

const showActiveProductInstallation = () => {
  const installationTabs = document.querySelectorAll(
    '[data-product-bundle-installation-tab]'
  );
  const installationProducts = document.querySelectorAll(
    '[data-product-bundle-installation-product]'
  );

  installationTabs.forEach((installationTab, index) => {
    installationTab.addEventListener('click', () => {
      const activeInstallationTab = document.querySelector(
        '[data-product-bundle-installation-tab][data-active="true"]'
      );
      const activeInstallationProduct = document.querySelector(
        '[data-product-bundle-installation-product][data-active="true"]'
      );

      activeInstallationTab.setAttribute('data-active', 'false');
      activeInstallationProduct.setAttribute('data-active', 'false');
      installationTab.setAttribute('data-active', 'true');
      installationProducts[index].setAttribute('data-active', 'true');
    });
  });
};

const mountStepsSlider = (el) => {
  new Splide(el, {
    type: 'loop',
    perPage: 1,
    perMove: 1,
    speed: 600,
    rewind: true,
    arrows: false,
    pagination: true,
    destroy: true,
    classes: {
      pagination:
        'splide__pagination product-bundle-installation__product-pagination',
      page: 'splide__pagination__page product-bundle-installation__product-pagination-btn',
    },
    breakpoints: {
      1024: {
        destroy: false,
      },
    },
  }).mount();
};

export const initBundleInstallation = () => {
  const stepsSliders = document.querySelectorAll(
    '[data-product-bundle-installation-steps-slider]'
  );

  showActiveProductInstallation();

  stepsSliders.forEach((stepsSlider) => {
    mountStepsSlider(stepsSlider);
  });
};
